





























import { Vue, Component, Prop } from "vue-property-decorator";
import { MButton } from "@ulaval/modul-components";
import store, { modules } from "../store";
import router from "../router";
import FenetreConfirmationAnnuler from "../components/FenetreConfirmationAnnuler.vue";
import { Casier } from "../models/Casier";

@Component({ components: { MButton, FenetreConfirmationAnnuler } })
export default class BoutonsNavigation extends Vue {
  @Prop({ type: Function })
  private suivant!: () => Promise<void>;
  @Prop({ type: Function })
  private precedent!: () => Promise<void>;
  @Prop({ type: Function })
  private annuler!: () => Promise<void>;

  private mounted(): void {
    store.commit(modules.trainProgression.mutations.desactiverSuivant.name);
  }

  private async navPrecedent(): Promise<void> {
    if (this.precedent !== undefined) {
      return this.precedent();
    }

    const route: string = await store.dispatch(
      modules.trainProgression.actions.etapePrecedente.name
    );
    router.push({ name: route });
  }

  private async navSuivant(): Promise<void> {
    if (this.suivant !== undefined) {
      return this.suivant();
    }

    const route: string = await store.dispatch(
      modules.trainProgression.actions.etapeSuivante.name
    );
    router.push({ name: route });
  }

  private lancerAnnulation(): void {
    store.commit(modules.trainProgression.mutations.lancerAnnulation.name);
  }

  private async navAnnuler(): Promise<void> {
    if (this.annuler !== undefined) {
      return this.annuler();
    }

    // Retrait du verrou si nécessaire
    if (this.casierUtilisateur !== null) {
      await store.dispatch(modules.cds.actions.retirerVerrouUtilisateur.name, {
        vm: this,
        idCasier: this.casierUtilisateur.id,
      });
    }

    store.commit(modules.minuteur.mutations.effacerStateMinuteur.name);
    store.commit(modules.utilisateur.mutations.effacerStateUtilisateur.name);

    const route: string = await store.dispatch(
      modules.trainProgression.actions.etapeDepart.name
    );
    router.push({ name: route });
  }

  private get precedentActive(): boolean {
    return store.state.trainProgression.precedentActive;
  }

  private get suivantActive(): boolean {
    return store.state.trainProgression.suivantActive;
  }

  private get suivantCache(): boolean {
    return store.state.trainProgression.suivantCache;
  }

  private get casierUtilisateur(): Casier | null {
    return store.state.utilisateur.casier;
  }
}
